jQuery(function($) {

    window.utilities = {}

    /**
     * Attributes
     *  - data-remove-from - Class or ID of a target element 
     *  - data-remove-class - Class to remove from the target element
     *  - data-prevent-default - Set to true to prevent default behavior eg. <a>
     *  - data-remove-multiple 
     *      - set to true if you want to remove multiple classes from multiple targets
     *      - separate data-remove-from and data-remove-class values by comma, classes will be removed from elements according to order
     * 
     * eg. <button data-remove-from="nav, .menu-icon" data-remove-class="active, show" data-multiple="true" data-prevent-default="true">Menu</button>
     */
    window.utilities.removeClass = function(e) {
        let $this = $(this)

        if ($this.data('prevent-default'))
            e.preventDefault()

        if ($this.data('remove-multiple')) {

            let elements = $this.data('remove-from').replace(/\s/g, '').split(',')
            let classes = $this.data('remove-class').replace(/\s/g, '').split(',')

            $.each(elements, function(key, value) {
                $(value).removeClass(classes[key])
            })

        } else {
            $($this.data('remove-from')).removeClass($this.data('remove-class'))
        }
    }

    /**
     * Attributes
     *  - data-add-to - Class or ID of a target element 
     *  - data-add-class - Class to add to the target element
     *  - data-prevent-default - Set to true to prevent default behavior eg. <a>
     *  - data-add-multiple 
     *      - set to true if you want to add multiple classes to multiple targets
     *      - separate data-add-to and data-add-class values by comma, classes will be added to elements according to order
     * 
     * eg. <button data-add-to="nav, .menu-icon" data-add-class="active, show" data-multiple="true" data-prevent-default="true">Menu</button>
     */
    window.utilities.addClass = function(e) {
        let $this = $(this)

        if ($this.data('prevent-default')) e.preventDefault()

        if ($this.data('add-multiple')) {

            let elements = $this.data('add-to').replace(/\s/g, '').split(',')
            let classes = $this.data('add-class').replace(/\s/g, '').split(',')

            $.each(elements, function(key, value) {
                $(value).addClass(classes[key])
            })

        } else {

            $($this.data('add-to')).addClass($this.data('add-class'))
        }
    }

    /**
     * Attributes
     *  - data-toggle-from - Class or ID of a target element 
     *  - data-toggle-class - Class to toggle from the target element
     *  - data-self-class - Class to this element
     *  - data-prevent-default - Set to true to prevent default behavior eg. <a>
     *  - data-toggle-multiple 
     *      - set to true if you want to toggle multiple classes to multiple targets
     *      - separate data-toggle-from and data-toggle-class values by comma, classes will be added to elements according to order
     * 
     * eg. <button data-toggle-from="nav, .menu-icon" data-toggle-class="active, show" data-multiple="true" data-prevent-default="true">Menu</button>
     */
    window.utilities.toggleClass = function(e) {
        let $this = $(this)
        let $trigger = $this

        if ($this.data('prevent-default')) e.preventDefault()

        if ($this.data('toggle-multiple')) {

            let elements = $this.data('toggle-from').replace(/, /g, ',').split(',')
            let classes = $this.data('toggle-class').replace(/, /g, ',').split(',')

            $.each(elements, function(key, value) {
                let $target = $(value)
                let selectors = null

                // if this is in the selector
                // reference the trigger object
                if (value.indexOf('this') !== -1) {
                    selectors = value.split(' ')
                    $target = $trigger.find(selectors[1])
                }

                if ($target.length > 1) {
                    $.each($target, function() {
                        $(this).toggleClass(classes[key])
                    })
                } else {
                    $target.toggleClass(classes[key])
                }
            })

        }

        if (!$this.data('toggle-multiple')) {
            let $target = $($this.data('toggle-from'))

            $.each($target, function() {
                let $element = $(this)
                let hasClass = $element.hasClass($this.data('toggle-class'))

                if (hasClass)
                    $element.removeClass($this.data('toggle-class'))

                if (!hasClass)
                    $element.addClass($this.data('toggle-class'))
            })
        }

        let selfClass = $this.data('self-class') ? true : false

        if (selfClass && $this.hasClass('clicked')) $this.removeClass('clicked')
        if (selfClass && !$this.hasClass('clicked')) $this.addClass('clicked')

    }

    window.utilities.slickInit = function() {
        if (typeof $.fn.slick == 'function')
            $('.slick').slick();
    }

    window.utilities.camelToSnake = function(string) {
        return string.replace(/[\w]([A-Z])/g, function(m) {
            return m[0] + "_" + m[1]
        }).toLowerCase()
    }

    window.utilities.scrollTo = function(target = null, offset = 0, speed = 1000, animated = true) {
        let $this = $(this)

        if ( $this.data('target') ) {
            target = $this.data('target') ? $this.data('target') : 'body'
            animated = $this.data('animated')
            speed = $this.data('speed') ? $this.data('speed') : 1000
            offset = $this.data('offset') ? $this.data('offset') : 0
        }

        if ( animated ) {
            $('html, body').animate({
                scrollTop: $(target).offset().top - offset
            }, speed)
        } else {
            $('html, body').scrollTop( $(target).offset().top )
        }
    }

    window.utilities.gdprInit = function() {
      let $gdpr = $('#footer-gdpr')
      let cookies = window.cookie.get('moove_gdpr_popup')

      if( cookies ) {
        $gdpr.remove()
      } else {
        $gdpr.removeClass('d-none')
      }
    }

    window.utilities.gdprSet = function() {
      let $gdpr = $('#footer-gdpr')
      let value = encodeURI('{"strict":"1","thirdparty":"1","advanced":"1"}');

      $gdpr.remove()
      window.cookie.set( 'moove_gdpr_popup', value, 365 )
    }

    window.utilities.redirect = function() {
      let $this = $(this)
      window.location.href = $this.data('redirect')
    }

    window.utilities.eventListeners = function() {
      let $body = $('body')
      let scrollTo = document.querySelectorAll('.scroll-to')

      $body
        .on( 'click', '[data-remove-from]', window.utilities.removeClass )
        .on( 'click', '[data-add-to]', window.utilities.addClass )
        .on( 'click', '[data-toggle-from]', window.utilities.toggleClass )
        .on( 'click', '.scroll-to', window.utilities.scrollTo )
        .on( 'click', '.accept-gdpr', window.utilities.gdprSet )
        .on( 'click', '[data-redirect]', window.utilities.redirect )
    }

    window.utilities.scrollTopObserver = function() {
      let header = document.getElementById('site-header')
      let scrollTopButton = document.getElementById('scroll-top')
      let observer = new IntersectionObserver( entries => {
        entries.forEach((entry) => {
          if( entry.isIntersecting ) {
            scrollTopButton.classList.remove('show')
          } else {
            scrollTopButton.classList.add('show')
          }
        })
      }, { threshold: 0 } )
      observer.observe( header )
    }

    window.utilities.slickInit()
    window.utilities.scrollTopObserver()
    window.utilities.eventListeners()
})



// WEBPACK FOOTER //
// ./src/js/utilities.js